import { PromoBadge } from '@adapters/bigcommerce/types/product';
import { DealsBannerStickerType } from '@adapters/prismic/types/pdpDealsBanner';

const SUPPORTED_STICKER_TYPES: Record<string, DealsBannerStickerType> = {
  sale: 'sale',
  clearance: 'clearance',
  new: 'new',
};

const getDealsBannerStickerTypes = (
  promoBadge?: { code?: PromoBadge['code'] | null } | null
): DealsBannerStickerType[] => {
  const normalizedCode = promoBadge?.code?.trim().toLowerCase();

  if (!normalizedCode) {
    return [];
  }

  const stickerType = SUPPORTED_STICKER_TYPES[normalizedCode];

  return stickerType ? [stickerType] : [];
};

export default getDealsBannerStickerTypes;
